"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.measureEquals = void 0;
const convert_measure_1 = require("../convert-measure/convert-measure");
const equal_with_tolerance_1 = require("../equal-with-tolerance/equal-with-tolerance");
/**
 * @summary Checks if two `Measure`s are equal.
 *
 * Checks if two `Measure` are the same in value, unit and options. The value is compared using a tolerance so that
 * values that are almost the same will be considered equal.
 *
 * @param {NullableMeasure} left
 * @param {NullableMeasure} right
 * @param {number | undefined} [tolerance]
 * @returns {boolean}
 *
 * @see equalWithTolerance
 *
 * @example
 * if (measureEquals(oldItem, newItem)) {
 *   // ...
 * }
 */
function measureEquals(left, right, tolerance) {
    if ((left.value == null && right.value != null) || (left.value != null && right.value == null)) {
        return false;
    }
    if (left.value == null && right.value == null) {
        return left.unit === right.unit || convert_measure_1.convertMeasure.canConvert(left.unit, right.unit);
    }
    if (left.unit === right.unit) {
        return (0, equal_with_tolerance_1.equalWithTolerance)(left.value, right.value, tolerance);
    }
    if (!convert_measure_1.convertMeasure.canConvert(left.unit, right.unit)) {
        return false;
    }
    return (0, equal_with_tolerance_1.equalWithTolerance)(left.value, (0, convert_measure_1.convertMeasure)(right, left.unit).value, tolerance);
}
exports.measureEquals = measureEquals;
